var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransnistria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#093",
    d: "M0 9h30v6H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "m6 1.2-.27.83h-.87l.7.51-.27.83.71-.51.7.51-.26-.83.7-.51h-.87zm0 0-.27.83h-.87l.7.51-.27.83.71-.51.7.51-.26-.83.7-.51h-.87z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "m4.07 5.54.6.6.56-.56C6.1 6.5 7 7.38 7.83 8.3c.14.13.34.13.47 0a.33.33 0 0 0 0-.46L5.56 5.26l.76-.76-1.05-.14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd900",
    d: "M6 3.6q.75.44 1.08 1.09c.23.42.33.85.33 1.2a1.3 1.3 0 0 1-2.27.87L5 6.88a.2.2 0 0 0-.22.05.3.3 0 0 0-.2.17q-.16.3-.48.42h-.01q-.16.06-.28.19c-.16.17-.24.38-.2.53a.12.12 0 0 0 .17.15c.15.03.35-.05.5-.2q.14-.15.2-.3a.8.8 0 0 1 .44-.5.3.3 0 0 0 .13-.16c.31.37.77.6 1.29.6.94.03 1.65-.66 1.68-1.66a2.6 2.6 0 0 0-.62-1.68c-.34-.4-.84-.74-1.4-.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransnistria);
export default __webpack_public_path__ + "static/media/transnistria.db05d31fd76516671c157bd442876a0b.svg";
export { ForwardRef as ReactComponent };